import { Tag, TagColumnFilter } from "@fdoh/health-react";
import { Link } from "react-router-dom";
import { CellProps } from "react-table";
import IconVideo from "../../../icons/IconVideo";


export const UserTrainingInputColumns = [
    // {
    //     Header: "Training Id",
    //     id:"trainingModuleId",
    //     accessor: (row: UserTrainingInput) => row.trainingModuleId,
    // },
    {
        Header: "Title",
        id:"trainingModuleName",
        accessor: (row: UserTrainingInput) => row.trainingModuleName,
    },
    {
        Header: "Date Uploaded",
        id:"dateCreated",        
        accessor: (row: UserTrainingInput) => new Date(row.dateCreated).toLocaleDateString(),
    },
    // {
    //     Header: "Status",new Date(abandonmentData?.tankPumpedDate).toLocaleDateString()
    //     id:"trainingStatus",
    //     accessor: (row: UserTrainingInput) => row.trainingStatus,
    // },
    // {
    //     Header: "Date Completed",
    //     id:"dateCompleted",
    //     accessor: (row: UserTrainingInput) => row.dateCompleted,
    // },
    {
        Header: "Actions",
        id:"trainingModulePath",
        accessor: (row: UserTrainingInput) =>
        (
            <>
                <div className="row">
                    <div className="col-sm-4">
                        <a title="Open" href={"/trainingVideos/" + row.trainingModuleId} >
                            <IconVideo />
                        </a>
                    </div>
                </div>                
            </>
        ),
        //accessor: (row: CountyEmailData) => row.value, 
    },
  ]

export type UserTrainingInput = {
    userTrainingId:number;
    userId:number;
    trainingModuleId:number;
    trainingStatus:number;
    dateCreated:Date | string;
    dateCompleted?:Date | string;
    trainingModuleName:string;
    trainingModulePath:string;
    isRequired:boolean;
    active?:boolean;
    sortOrder:number;

}